import React, {forwardRef} from 'react';
import styled from 'styled-components';
import {LoadingSpinner} from './LoadingSpinner';

interface LoadingPageSpinnerProps {
  className?: string;
}

export const LoadingPageSpinner = forwardRef<
  HTMLDivElement,
  LoadingPageSpinnerProps
>(function LoadingPageSpinner({className}, ref) {
  return (
    <Wrapper ref={ref} className={className}>
      <LoadingSpinner />
    </Wrapper>
  );
});

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 75vh;
`;
